import Vue from 'vue'
import App from './App.vue'
import router from './router'
require('./bootstrap');
// import store from './store'

import '@/assets/sass/style.scss'

// Import Font Awesome
import '@fortawesome/fontawesome-free/css/all.css'

import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

Vue.use(VueFormWizard)




// AJOUT OBLIGATOIRE ! 🔥🔥🔥
import VueRouter from 'vue-router'
Vue.use(VueRouter)

// 🔥 Firebase
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'

//Vue editor
import VueEditor from 'vue2-editor'

Vue.use(VueEditor)
// 🔧 Vuelidate
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

// 🔧 Loading Overlay
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
Vue.use(Loading, {
  isFullPage: false,
  canCancel: false,
  loader: 'spinner'
})

// 🔧 Element UI
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/fr'
import 'element-ui/lib/theme-chalk/index.css'
import 'material-icons/iconfont/material-icons.css';
Vue.use(ElementUI, { locale })



// 🔧 Vue Moment
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
require('moment/locale/fr')
Vue.use(VueMoment, { moment })

// // 🔧 HTML2Canvas
// import VueHtml2Canvas from 'vue-html2canvas'
// Vue.use(VueHtml2Canvas)






Vue.filter('toLetter', function(value){
    return NumberToLetter(value)
 })
 Vue.filter('reduceParagraphLength', function (value) {
    if (!value || typeof (value) !== 'string') {
      return '';
    }
  
    const maxLength = 100;
    const plainText = value.replace(/<\/?[^>]+(>|$)/g, '');
    const length = plainText.length;
  
    if (length > maxLength) {
      return `${plainText.slice(0, maxLength)}...`;
    } else {
      return value;
    }
  });
  
 Vue.filter('normalized', function (value) {
     return (value.charAt(0).toUpperCase() + value.substring(1).toLowerCase())
 })
 
 Vue.filter('capitalized', function (value) {
     if (!value) return "";
     return value.toUpperCase()
 })
 
 Vue.filter('cyb_txt_split', function (value) {
     if (!value) return "détails";
     let res = "";
     let formatText = value.replace(/<\/?[^>]+(>|$)/g, "")
     let len = formatText.length;
     if (len > 14) {
         res = value.substr(0, 11);
         return res + "...";
     } else {
         return value;
     }
 })
 Vue.filter('cyb_txt_switch_split', function (value) {
    if (!value) return "détails";
    let res = "";
    let formatText = value.replace(/<\/?[^>]+(>|$)/g, "")
    let len = formatText.length;
    if (len > 20) {
        res = value.substr(0, 20);
        return res + "...";
    } else {
        return value;
    }
})
 Vue.filter('cyb_description_split', function (value) {
     if (!value) return "";
     let res = "";
     let formatText = value.replace(/<\/?[^>]+(>|$)/g, "")
     let len = formatText.length;
     if (len > 20) {
         res = value.substr(0, 20);
         return res + "...";
     } else {
         return value;
     }
 })
 Vue.filter('cyb_descParam_split', function (value) {
     if (!value) return "";
     let res = "";
     let formatText = value.replace(/<\/?[^>]+(>|$)/g, "")
     let len = formatText.length;
     if (len > 15) {
         res = value.substr(0, 30);
         return res + "...";
     } else {
         return value;
     }
 })
 Vue.filter('cyb_desc_split', function (value) {
     if (!value) return "";
     let res = "";
     let formatText = value.replace(/<\/?[^>]+(>|$)/g, "")
     let len = formatText.length;
     if (len > 36) {
         res = value.substr(0, 30);
         return res + "...";
     } else {
         return value;
     }
 })
 Vue.filter('cyb_date_split', function (value) {
     if (!value) return "";
     let res = "";
     let len = value.length;
     if (len > 12) {
         res = value.substr(0, 9);
         return res + "...";
     } else {
         return value;
     }
 })
 Vue.filter('cyb_title_plit', function (value) {
     if (!value) return "";
     let res = "";
     let len = value.length;
     if (len > 21) {
         res = value.substr(0, 15);
         return res + "...";
     } else {
         return value;
     }
 })
 Vue.filter('cyb_title_project_plit', function (value) {
     if (!value) return "";
     let res = "";
     let len = value.length;
     if (len > 21) {
         res = value.substr(0, 17);
         return res + "...";
     } else {
         return value;
     }
 })
 Vue.filter('cyb_title_param_plit', function (value) {
     if (!value) return "";
     let res = "";
     let len = value.length;
     if (len > 10) {
         res = value.substr(0, 15);
         return res + "...";
     } else {
         return value;
     }
 })
 Vue.filter('cyb_name_plit', function (value) {
     if (!value) return "";
     let res = "";
     let len = value.length;
     if (len > 21) {
         res = value.substr(0, 19);
         return res + "...";
     } else {
         return value;
     }
 })
 Vue.filter('cyb_denomination_split', function (value) {
     if (!value) return "";
     let res = "";
     let len = value.length;
     if (len > 100) {
         res = value.substr(0, 100);
         return res + "...";
     } else {
         return value;
     }
 })
 Vue.filter('cyb_userPicName_split', function (value) {
     if (!value) return "";
     let res = "";
     let len = value.length;
     if (len > 6) {
         res = value.substr(0, 6);
         return res + "...";
     } else {
         return value;
     }
 })
 
 Vue.filter('cyb_descCategorie_split', function (value) {
     if (!value) return "";
     let res = "";
     let len = value.length;
     if (len > 20) {
         res = value.substr(0, 20);
         return res + "...";
     } else {
         return value;
     }
 })
// 🔥 Firebase config
const config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
}

firebase.initializeApp(config)
firebase.firestore().settings({ cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED })

Vue.prototype.$firestore = firebase.firestore()
Vue.prototype.$firestorage = firebase.storage()

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
